import { formatMillisecondsToDate } from "@/storeAdmin/utils";

const preferredDealersExcelHeader = [
    "License ID",
    "Business Name",
    "Total Transfers",
    "RBDI",
    "Is Claimed",
    "Primary Contact",
    "Primary Phone",
    "Rating",
    "Reviews",
    "Expiry Date",
    "Has Valid License",
    "Is SOT",
    "Has SOT Tax Stamp",
    "Opt-In Status",
    "Opt-Out Status",
    "Transfer Email",
    "Handgun Fee",
    "Long Gun Fee",
    "Other Firearm Fee",
    "NFA Fee",
    "Website",
    "Facebook",
    "Business Category",
    "Primary Business Indicator",
    "CFD",
    "Shooting Range",
    "Is Big Box Retailer",
    "Open on Weekends", 
    "FFL License Type", 
    "Services",
    "Blacklisted Stores Count",
    "Operational status",
    "Premise Address"
];

const truncateText = (text: any, maxLength = 32760) => {
  if (!text) return '';
  const textStr = text.toString();
  if (textStr.length <= maxLength) return textStr;
  return textStr.substring(0, maxLength - 3) + '...';
};

const safeJoinArray = (arr: any, separator = ', ', maxLength = 32760) => {
  if (!Array.isArray(arr)) return truncateText(arr);
  
  let result = '';
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i] || '';
    const newResult = result ? `${result}${separator}${item}` : item;
    
    if (newResult.length > maxLength - 3) {
      return result + '...';
    }
    result = newResult;
  }
  return result;
};

export default class PreferredDealersReportBuilder {
    static buildPreferredDealers(item: any) {
        return [
            truncateText(item?.licenses[0]?.licenseKey || ""),
            truncateText(item?.primaryBusinessName || "-"),
            truncateText(item?.totalTransferCounts?.toString() || "0"),
            truncateText(typeof item?.isCommercial === 'boolean' ? (item?.isCommercial ? "Commercial" : "Residential") : "-"),
            truncateText(item?.isClaimed ? "Yes" : "No"),
            truncateText(item?.contact?.value || "-"),
            truncateText((item?.phoneNumbers && item?.phoneNumbers[0]) || "-"),
            truncateText(item?.consolidatedRatings?.ratings ? String(item?.consolidatedRatings?.ratings) : "-"),
            truncateText(item?.consolidatedRatings?.reviews ? String(item?.consolidatedRatings?.reviews) : "-"),
            truncateText(formatMillisecondsToDate(item?.licenses[0]?.expiryDate) || ""),
            truncateText(item?.licenseTypes[0]?.hasValidCertificate ? "Yes" : "No"),
            truncateText(item?.isSotDealer ? "Yes" : "No"),
            truncateText(item?.sot?.employeeIdentificationNumber ? "Yes" : "No"),
            truncateText(item?.optedInAllStores ? "Opted In All Stores" : item?.optedInForStore ? "Opted In This Store" : ""),
            truncateText(item?.optedOutAllStores ? "Opted Out All Stores" : item?.optedOutForStore ? "Opted Out This Store" : ""),
            safeJoinArray(item?.emails, ', ') || "-",
            truncateText(item?.firearms?.handGun ? item?.firearms?.handGun : "-"),
            truncateText(item?.firearms?.longGun ? item?.firearms?.longGun : "-"),
            truncateText(item?.firearms?.other ? item?.firearms?.other : "-"),
            truncateText(item?.firearms?.nfa ? item?.firearms?.nfa : "-"),
            truncateText(item?.website ? item?.website : "-"),
            truncateText(item?.socialProfiles?.facebook ? item?.socialProfiles?.facebook : "-"),
            safeJoinArray(item?.businessTypes, ', ') || '-',
            truncateText(item?.primaryBusiness ? 'Yes' : 'No'),
            truncateText(item?.cfd ? item?.cfd : '-'),
            truncateText(item?.isRangeDealer ? 'Yes' : 'No'),
            truncateText(item?.isBigBoxRetailer ? 'Yes' : 'No'),
            truncateText(item?.openOnWeekends ? 'Yes' : 'No'),
            truncateText(this.getLicenseTypes(item?.licenseTypes)),
            safeJoinArray(item?.services, ', ') || "-",
            truncateText(item?.blackListedStoresCount?.toString() || "0"),
            truncateText(item?.isPermanentlyClosed ? "Permanently Closed" : item?.isTemporarilyClosed ? "Temporarily Closed" : "Operational"),
            truncateText(`${item?.address?.street || ''}, ${item?.address?.city || ''}, ${item?.address?.state || ''}, ${item?.address?.zipCode || ''}`)
        ];
    }

    static buildPreferredDealersReportList(data: any): any[] {
        const result = data.map((item: any) => PreferredDealersReportBuilder.buildPreferredDealers(item));
        return [preferredDealersExcelHeader, ...result];
    }

    static getLicenseTypes(licenseTypes: any) {
        const licenseType: any = []
        licenseTypes?.map((record: any) => licenseType.push(record?.type))
        return licenseType.join(", ")
    }
}